import { useState } from 'react';


import { SlotsTimePicker } from './SlotsTimePicker';
import { getFormatedTimeString } from '../Helper/utils'


export const SlotsCellView = ({ setDoctorSlots, data, durationKey, day, doctorSlots, handleDelete, makeFormDirty, parentId }) => {
    const [timePicker, setTimePicker] = useState(false);
    return (
        <div className="flex flex-row gap-2 justify-between w-full">
            {(data[durationKey]?.totalSlots == 0) && <div className={"flex justify-center align-center "}>
                <SlotsTimePicker
                    setDoctorSlots={setDoctorSlots}
                    doctorSlots={doctorSlots}
                    durationKey={durationKey}
                    day={day}
                    makeFormDirty={makeFormDirty}
                    parentId={parentId}
                />
            </div>
            }

            {data[durationKey]?.totalSlots != 0 && (!timePicker) ?
                <>
                    <p className=" text-start text-[#47566A] ">
                        <div className="block  justify-start ">
                            {getFormatedTimeString(data[durationKey].startTime)} to {getFormatedTimeString(data[durationKey].endTime)}
                        </div>
                        <div className="flex flex-row gap-2 font-light" style={{ fontWeight: 300 }}>
                            Avg. {data[durationKey].split} mins, {data[durationKey].totalSlots} bookings
                        </div>
                    </p>
                    <div className="flex flex-row gap-6 px-4">
                        {<>
                            <img src="https://views.medibuddy.in/providerUi/assets/editIcon.svg" alt="Edit" onClick={(e) => { e.preventDefault(); setTimePicker(true) }} width={20} height={20} style={{ cursor: 'pointer' }} />
                        </>
                        }
                        <img src="https://views.medibuddy.in/providerUi/assets/deleteIcon.svg" onClick={(e) => { e.preventDefault(); handleDelete(data, durationKey, day) }} width={20} height={20} style={{ cursor: 'pointer' }} alt="Delete" />
                    </div>
                </>
                : <>

                    {timePicker &&
                        <SlotsTimePicker
                            isEditing={true}
                            setTimePicker={setTimePicker}
                            setDoctorSlots={setDoctorSlots}
                            doctorSlots={doctorSlots}
                            durationKey={durationKey}
                            day={day}
                            data={data}
                            makeFormDirty={makeFormDirty}
                            parentId={parentId}
                        />
                    }

                </>
            }

        </div>
    )
}